var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',_vm._b({attrs:{"options":_vm.simpleUnitList,"placeholder":_vm.placeholder,"loading":_vm.loading,"track-by":"id","label":"name","value":_vm.selectedUnit},on:{"select":_vm.onUnitSelected}},'multiselect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }